module.exports = __webpack_public_path__ + "img/2_20.f4c831e5.png";